export default __webpack_public_path__ + "static/media/Trixie_9781408333013.5ab79400.jpg";